import { Trans } from "@lingui/react/macro";
import { Badge } from "@warp-ds/elements/react/badge";
import { useAdViewMeta } from "src/context/AdViewProviderContext.tsx";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";

type Props = {
  disposedText?: string;
};
const StatusTag = ({ disposedText }: Props) => {
  const { mode } = useAdViewMeta();
  const { isPreview } = useAppConfig();
  const inactive = mode !== "PLAY";

  if (isPreview) {
    return null;
  }

  if (disposedText) {
    return (
      <div className="pb-8">
        <Badge variant="warning">{disposedText.toUpperCase()}</Badge>
      </div>
    );
  }
  if (inactive) {
    return (
      <div className="pb-8">
        <Badge variant="negative">
          <Trans id="itemPageLayout.statusTag.inactive">Inactive</Trans>
        </Badge>
      </div>
    );
  }
  return null;
};

export default StatusTag;
